
export type AdminDebugSubscription200DataMetadata = { [key: string]: unknown };
